export enum StatusApprovalRequest {
    AguardandoAprovacao = 0,
    Aprovado = 1,
    Rejeitado = 2
}